<template>
    <div>
        <div class="text-left text-sm mb-4">
            {{ section.guidance }}
        </div>
        <div v-if="!!section.form" class="text-left">
            <formio :form="section.form" :submission="{data: formData}" :readonly="readonly" :options="{readOnly: readonly, renderMode: readonly ? 'html' : 'form'}" @change="updateData" />
        </div>
        <div v-if="!section.form">
            {{ fallback }}
        </div>
        <div v-if="successMessage.length > 0" class="success-message m-8 w-auto">{{ successMessage }}</div>
        <div v-if="!readonly" class="relative w-auto lg:w-1/3">
            <application-component-save-button :disabled="formDirty"
                                               class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                               type="button" @click="update"
            >
                Save {{ section.title }}
                <div v-if="loading" class="lds-ring-container absolute top-10">
                    <div class="lds-ring">
                        <div />
                        <div />
                        <div />
                        <div />
                    </div>
                </div>
            </application-component-save-button>
        </div>
    </div>
</template>

<script>
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'
import TextareaInput from '@/shared/TextareaInput'
import { Form } from '@formio/vue'

export default {
  components: {
    ApplicationComponentSaveButton,
    TextareaInput,
    formio: Form,
  },
  props: {
    section: Object,
    sectionData: Object,
    applicationId: String,
    fallback: String,
    readonly: false,
  },
  data() {
    return {
      maximumWordCount: 500,
      formDirty: false,
      loading: false,
      successMessage: '',
      serverError: '',
      formData: this.sectionData[this.section.key],
    }
  },
  computed: {
    // wordCount() {
    //   if (this.applicationData.personal_statement === null || this.applicationData.personal_statement === undefined)
    //   {
    //     return 0
    //   }
    //   return this.applicationData.personal_statement.match(/\s+/g)?.length || 0
    // },
  },
  mounted() {
    this.maximumWordCount = process.env.VUE_APP_MAXIMUM_WORD_COUNT || 500
  },
  methods: {
    update() {
      this.loading = true
      this.$store.dispatch('updateSectionData', {
        sectionKey: this.section.key,
        sectionData: {
          data: this.formData,
          key: this.section.key,
        },
        applicationId: this.applicationId,
      })
          .then((response) => {
            this.loading = false
            this.successMessage = response.data
            this.serverError = ''
          })
          .catch(error => {
            this.loading = false
            this.successMessage = ''
            this.serverError = error.response.data
          })
      this.formDirty = false
    },
    dirtyForm() {
      this.formDirty = true
      this.successMessage = ''
    },
    updateData(event) {
      if(event.data) {
        this.formData = event.data
      }
      this.formDirty = !!event.isValid || event.type === 'change'
    },
  },
}
</script>